import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AssignedDto } from "../../types/user.dto";

interface AssignedState {
    assigned: AssignedDto[];
    isLoading: boolean;
}
const initialState: AssignedState = {
    assigned: [],
    isLoading: false,
};

export const assignedState = createSlice({
    name: "assigned",
    initialState,
    reducers: {
        setAssigned: (state, action: PayloadAction<AssignedDto[]>) => {
            state.assigned = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export const { setIsLoading, setAssigned } = assignedState.actions;
export default assignedState.reducer;
